/**
 * 邮箱
 * @param {*} s
 */
export function isEmail (s) {
  return /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+((.[a-zA-Z0-9_-]{2,3}){1,2})$/.test(s)
}

/**
 * 手机号码
 * @param {*} s
 */
export function isMobile (s) {
  return /^1[0-9]{10}$/.test(s)
}

/**
 * 电话号码
 * @param {*} s
 */
export function isPhone (s) {
  return /^([0-9]{3,4}-)?[0-9]{7,8}$/.test(s)
}

/**
 * URL地址
 * @param {*} s
 */
export function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 校验金额
 * @param {*} value
 */
export function isAmount(value){
  if(!value){
    return false;
  }else{
    if(new RegExp("/^[1-9]\\d{0,5}|0)|(([1-9]\\d{0,3}|0)\\.\\d$/").test(value)){
      return true;
    }else{
      return false;
    }
  }
}

/**
 * 校验身份证号码
 * @param {*} value
 */
export function isIdCardNumber(value){
  //1.判断身份证号码
  const rr = /^[1-9]\d{1}(.{13}|.{16})$/
  if(rr.test(value)){
    if(value.length==18){
      //加权因子
      let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验位
      let check_code = [1, 0, 'X', 9, 8, 7, 6, 5, 4, 3, 2]
      let idWiSum = 0
      for(let i =0; i<17 ;i++){
        idWiSum += value.substring(i,i+1)*weight_factor[i]
      }
      //计算模
      let idMod = idWiSum % 11
      let idLastCode = check_code[idMod]
      if(value[17] == idLastCode){
        //校验成功
        return true;
      } else {
        return false;
      }
    }
  }else{
    return false;
  }
}